import { PrivateLayout, PublicLayout } from "../layout";
import privateRoutes from "./private.route";
import publicRoutes from "./public.route";


export const userRoutes = () => {
  return [
    {
      element: <PublicLayout />,
      children: [...publicRoutes()],
    },
    {
      element: <PrivateLayout />,
      children: [...privateRoutes()],
    },
  ];
};